import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface UserInfo {
  nombre_usuario: string | null;
  organo: string | null;
  rol: number | null;
}

@Injectable({
  providedIn: 'root' 
})

export class UserService {
  private _userInfo = new BehaviorSubject<UserInfo>({
    nombre_usuario: null,
    organo: null,
    rol: null,
  });
 
  public readonly userInfo$: Observable<UserInfo> = this._userInfo.asObservable();

  constructor() { }

  setUserInfo(parcial: Partial<UserInfo>) {
    const actual = this._userInfo.value;
    const actualizado = { ...actual, ...parcial };
    this._userInfo.next(actualizado);
  }

  getUserInfo(): UserInfo {
    return this._userInfo.getValue();
  }

}
